<template>
    <div>
        <div class="flex gap-2 mb-4">
            <label class="w-14 flex-shrink-0 text-sm">Preset</label>
            <div class="flex flex-wrap gap-1">
                <div @click="setColorDots(color)" v-for="(color, i) in color_sample" :key="i"
                    class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer hover:border-white hover:drop-shadow-sm"
                    :style="{ backgroundColor: color }" :class="{
                        'border-white shadow shadow-sky-600': CheckColorSelected('dotsOptions', color),
                    }"></div>
            </div>
        </div>
        <div class="mb-4 flex gap-2">
            <label class="w-14 flex-shrink-0 text-sm">Picker</label>
            <div class="flex flex-wrap gap-1">
                <color-picker v-model:pureColor="color_picker" :format="'hex'" :pickerType="'chrome'"
                    :disableAlpha="true" :shape="'circle'" :isWidget="false" />
            </div>
        </div>
        <div class="mb-4 mt-4 h-[1px] w-full bg-gray-300"></div>
        <div class="flex flex-wrap gap-2 mb-4">
            <label class="w-14 flex-shrink-0 text-sm">Recent </label>
            <div v-for="(color, i) in used_colors.slice(0, 6)" :key="i"
                class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer" @click="setColorDots(color)"
                :style="{ backgroundColor: color }"></div>
        </div>
    </div>
</template>
  
<script>
import { PaletteIcon } from "vue-tabler-icons";
import configMixins from "../config.mixin";
import { useQrCreateStore } from "~~/stores/qrcreate";

export default {
    mixins: [configMixins],
    data() {
        return {
            color_picker: "",
            color_sample: [
                "#ffffff",
                "#f4f4f4",
                "#ede9e2",
                "#efe2e2",
                "#d1e5db",
                "#dfeaf0",
                "#ceddeb",
                "#ededed",
                "#d9dee0",
                "#bac3cc",
                "#77818c",
                "#3f4b59",
                "#25303b",
                "#0b0d0f",
                "#3d193d",
                "#ad2e1b",
                "#ce3b34",
                "#ce6328",
                "#20985a",
                "#257d46",
                "#05363d",
                "#243565",
                "#205792",
                "#45688e",
                "#5f77b0",
                "#576b95",
                "#3d5b96",
                "#223e83",
            ],
        };
    },
    methods: {
        changeColor({ color, index }) {
            this.setColorDots(color);
        },
        setColorDots(color) {
            useQrCreateStore().setColorByKey({ key: "dotsOptions", color });
        },
       
    },
    components: { PaletteIcon },
    mounted() {
        if (this.config.dotsOptions.color) {
            this.color_picker = this.config.dotsOptions.color
            this.$watch('color_picker', this.setColorDots)
        }
    },
    watch: {

    }
};
</script>
  